document.addEventListener('DOMContentLoaded', function () {
  const taxRates = {
    '__tva00': 0,
    '__tva0': 0,
    '__tva55': 0.055,
    '__tva2000': 0.20
  };

  const DEFAULT_TAX_RATE = 0.20;

  function getProductTaxRate() {
    const productTags = Array.isArray(window.wholesaleProductTags)
      ? window.wholesaleProductTags
      : [];

    for (const [tag, rate] of Object.entries(taxRates)) {
      if (productTags.includes(tag)) {
        return rate;
      }
    }

    return DEFAULT_TAX_RATE;
  }

  function parsePrice(text) {
    const normalizedValue = text
      .replace(/\u00a0/g, '')
      .replace(/\s/g, '')
      .replace(',', '.')
      .replace(/[^\d.-]/g, '');

    return Number.parseFloat(normalizedValue);
  }

  function formatPrice(price) {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  }

  function convertPriceElement(priceElement, taxRate) {
    const currentText = priceElement.textContent.trim();

    /*
     * Le prix affiché correspond déjà à la dernière valeur TTC
     * créée par notre script.
     */
    if (priceElement.dataset.ttcDisplayed === currentText) {
      return;
    }

    const netPrice = parsePrice(currentText);

    if (!Number.isFinite(netPrice)) {
      return;
    }

    const grossPrice = netPrice * (1 + taxRate);
    const grossPriceText = formatPrice(grossPrice);

    priceElement.dataset.netPriceSource = netPrice.toString();
    priceElement.dataset.taxRate = taxRate.toString();
    priceElement.dataset.ttcDisplayed = grossPriceText;

    priceElement.textContent = grossPriceText;
  }

  /*
   * Fiche produit
   */
  function convertWholesaleProductPrices() {
    const taxRate = getProductTaxRate();

    document
      .querySelectorAll('.price.wsdapp .price__current .money .money')
      .forEach(function (priceElement) {
        convertPriceElement(priceElement, taxRate);
      });
  }

  /*
   * Panier principal
   */
  function convertWholesaleCartPrices() {
    document.querySelectorAll('.cart-item[data-tax-rate]').forEach(
      function (cartItem) {
        const taxRate = Number.parseFloat(cartItem.dataset.taxRate);

        if (!Number.isFinite(taxRate)) {
          return;
        }

        const priceElement = cartItem.querySelector(
          '.cart-item__total.price > .cart-item__total > .money > .money'
        );

        if (!priceElement) {
          return;
        }

        convertPriceElement(priceElement, taxRate);
      }
    );
  }

  function convertAllWholesalePrices() {
    convertWholesaleProductPrices();
    convertWholesaleCartPrices();
  }

  convertAllWholesalePrices();

  let conversionScheduled = false;

  const observer = new MutationObserver(function (mutations) {
    const relevantChange = mutations.some(function (mutation) {
      const target = mutation.target.nodeType === Node.TEXT_NODE
        ? mutation.target.parentElement
        : mutation.target;

      if (!target || !target.closest) {
        return false;
      }

      return Boolean(
        target.closest('.price.wsdapp') ||
        target.closest('.cart-item[data-tax-rate]')
      );
    });

    if (!relevantChange || conversionScheduled) {
      return;
    }

    conversionScheduled = true;

    requestAnimationFrame(function () {
      convertAllWholesalePrices();
      conversionScheduled = false;
    });
  });

  observer.observe(document.body, {
    childList: true,
    characterData: true,
    subtree: true
  });
});